<template>
    <div class="header">
        <div class="header-left">
            <h1>Footer Settings</h1>
            <p>
                You can upload
                <b>an existing XLSX file with participant information.</b> You can match the data in the next steps (Email is required).
            </p>
        </div>
        <div class="header-right">
            <a-button type="primary" class="save-btn" @click="emitSaveOptions">Save Options</a-button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        emitSaveOptions () {
            this.$emit('save');
        },
    },
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #CBCBE4;
    padding: 25px 40px;
    .header-left {
        h1 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 28px;
            color: #001529;
        }
        p {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #001529;
        }
    }
    .header-right {
        .save-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 142px;
            height: 40px;
            background: #4bc076;
            border-radius: 0;
            border: none;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;
        }
    }
}
</style>

